import styles from './EmailSubscriber.module.scss';
import React, { Fragment, PureComponent } from 'react';
import classNames from 'classnames';
import { subscribeNewsLetter } from 'src/lib/api';
import { Text } from 'src/components/Text/Text';
import Icon from 'src/components/Icon/Icon';
import { connect } from 'react-redux';
import TrackingManager from 'src/lib/managers/TrackingManager';
import withParsedQuery from 'src/lib/hoc/withParsedQuery';
import { getCurrentCategoryPage } from 'src/lib/redux/modules/settings';
import withDictionary from 'src/lib/hoc/withDictionary';
import withWhoAmI from 'src/lib/hoc/withWhoAmI';

@connect(
	state => ({
		category: getCurrentCategoryPage(state.settings),
	}),
	dispatch => ({
		dispatch,
	})
)
@withParsedQuery()
@withDictionary()
@withWhoAmI()
export class EmailSubscriber extends PureComponent {
	state = {
		value: '',
		invalid: false,
		subscriptionSuccess: false,
		disableButton: false,
		throttleTime: 5000,
	};

	handleChange = event => {
		this.setState({
			value: event.target.value,
		});
	};

	updateView = () => {
		const { throttleTime } = this.state;

		this.setState({
			disableButton: true,
			invalid: false,
			subscriptionSuccess: false,
			loading: true,
		});
		setTimeout(() => {
			this.setState({
				disableButton: false,
			});
		}, throttleTime);
	};

	handleSubmit = event => {
		const { value } = this.state;
		const { parsedQuery, category, whoami } = this.props;
		const { FULL_DOMAIN } = whoami;
		const domain = FULL_DOMAIN.toLowerCase();

		event.preventDefault();
		if (!value) {
			this.setState({
				invalid: true,
			});
			return;
		}
		this.updateView();
		TrackingManager.trackEvent('Subscribe', { section: location.pathname });
		subscribeNewsLetter(
			{
				email: value,
				page: location.pathname,
				mailingList: `subscribe@${domain}`,
				domain,
				category: (() => {
					if (category && category.categoryId) {
						return {
							id: category.categoryId,
							name: (category.categoryName || '').replace(/-/g, ' '),
						};
					}
					return {};
				})(),
			},
			parsedQuery
		).then(() => {
			this.setState({
				subscriptionSuccess: true,
				value: '',
				loading: false,
			});
		});
	};

	renderButtonContent = () => {
		const { loading, subscriptionSuccess, disableButton } = this.state;
		const { dictionary } = this.props;

		if (loading) {
			return <img src="/fresh/images/blue-spinner.svg" alt="" />;
		}
		if (subscriptionSuccess && disableButton) {
			return <Icon url={'/shared/images/images_fs-icons_check-circle.svg'} />;
		}
		return dictionary('Subscribe');
	};

	render() {
		const { value, invalid, subscriptionSuccess, disableButton } = this.state;
		const { dictionary } = this.props;

		return (
			<Fragment>
				<form className={styles.wrapper} onSubmit={this.handleSubmit}>
					<input
						type={'email'}
						value={value}
						onChange={this.handleChange}
						placeholder={dictionary('Enter your email')}
						className={classNames(styles.input, invalid ? styles.invalid : '')}
					/>
					<button type={'submit'} className={styles.button} disabled={disableButton}>
						{this.renderButtonContent()}
					</button>
				</form>
				<Text className={classNames(styles.subscriptionResult, subscriptionSuccess && disableButton ? styles.success : '')}>
					{dictionary('Thank you for subscription')}
				</Text>
			</Fragment>
		);
	}
}
